import gql from 'graphql-tag';

export const WatchDialogQueryWithWatchChildren = gql`
	query WatchDialogQueryWithWatchChildren($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			...WatchDialogContentFragmentWithWatchChildren
		}
	}

	fragment WatchDialogContentFragmentWithWatchChildren on Content {
		id
		currentUserIsWatching
		currentUserIsWatchingChildren
		currentUserHasAncestorWatchingChildren
		type
		space {
			id
			key
			currentUser {
				isWatched
				isWatchingBlogs
			}
			operations {
				operation
				targetType
			}
		}
	}
`;
